import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApplicantManagementService } from 'src/modules/profile-management/services/applicant-management-service.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';

@Component({
  selector: 'app-ekey-redirect-page',
  templateUrl: './ekey-redirect-page.component.html',
  styleUrls: ['./ekey-redirect-page.component.scss']
})
export class EkeyRedirectPageComponent implements OnInit {

//#region [Variables]
  loginURL: string;
  redirectMessage: string = '';
//#endregion

//#region [LifeCycle]
  constructor(
    private router: Router,
    private appConfig: AppConfigService,
    private translate: TranslateService,
    private applicantService: ApplicantManagementService,) {
      this.translate.get("Login-container.Labels.LoginRedirection").subscribe(translatedValue => {
        this.redirectMessage = translatedValue;
      });

      let isProduction = JSON.parse(this.appConfig.getAppConfig().IsProduction);
      if (isProduction) {
        this.GetSessionId();
      } else {
        let parentUrl = document.location.origin;
        window.location.replace(parentUrl+'/login/email');
      }
    }
  ngOnInit() {}
//#endregion

//#region [Requests]
private GetSessionId(){
  this.applicantService.RequestAuthentication().subscribe(
    response => {
      if (response["Status"] === "Success") {
        if (response["Result"] && response["Result"] != "") {
            this.loginURL = this.appConfig.getAppConfig().LoginURL;
            let url = `${this.loginURL}?sessionid=${response["Result"]}`;

            window.location.replace(url);
          }else {
            this.router.navigate(['/error']);
          }
    } else {
      this.router.navigate(['/error']);
    }
  },(err) => {
    this.router.navigate(['/error']);
  });
}
//#endregion

}
